import { ReactNode } from 'react'
import { useImmer } from 'use-immer'
import { FormContext } from '../FormContext'
import { FormSubmitHandler } from '../types'

export interface RootProps<T extends { [key: string]: any }> {
  children: ReactNode
  defaultValue: T
  onSubmit?: FormSubmitHandler<T>
}

export const Root = <T extends { [key: string]: any }>({
  children,
  onSubmit,
  defaultValue
}: RootProps<T>) => {
  const [formData, setFormData] = useImmer<T>(defaultValue)
  const [errors, setErrors] = useImmer<Record<string, string>>({})

  const hasErrors = (): boolean => {
    return Object.keys(errors).length > 0
  }

  return (
    <FormContext.Provider value={{ formData, setFormData, errors, setErrors, hasErrors }}>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          if (hasErrors()) return
          if (onSubmit) onSubmit(formData)
        }}
      >
        {children}
      </form>
    </FormContext.Provider>
  )
}
